import { useSelector } from 'react-redux'

import {
  selectCompaniesData,
  selectCompaniesFetched,
  selectShouldFetch
} from 'redux/selectors/Companies'

export const useShouldFetchCompanies = () => {
  return useSelector(selectShouldFetch)
}

export const useCompaniesData = () => {
  return useSelector(selectCompaniesData)
}

export const useCompaniesFetched = () => {
  return useSelector(selectCompaniesFetched)
}
